module.exports = __webpack_public_path__ + "static/media/corosion.37983bee.jpeg";